
import React from 'react';

const softwareData = [
  {
    id: 'quickbooks',
    number: 1,
    name: 'QuickBooks Online',
    tagline: 'The Industry Standard for Small Business',
    image: 'https://public.readdy.ai/ai/img_res/ae02e6633992b6a39dffa7c015c659b9.jpg',
    imageAlt: 'quickbooks-online-cloud-accounting-software-dashboard',
    price: 'Starting at $30/month',
    bestFor: 'Growing small to mid-sized businesses',
    paragraphs: [
      'QuickBooks Online remains the gold standard in cloud-based accounting software, and for good reason. Developed by Intuit, it offers an incredibly robust feature set that scales with your business. From basic invoicing and expense tracking to advanced inventory management and multi-currency support, QuickBooks Online covers virtually every financial need a small business could have.',
      'One of the biggest advantages of QuickBooks Online is its massive ecosystem of integrations. With over 750 third‑party apps connecting seamlessly to the platform, you can link your bank accounts, payment processors, payroll services, and even your point‑of‑sale system into one unified financial hub. For El Paso businesses that rely on multiple tools to run their operations, this connectivity is invaluable.',
      'The reporting capabilities in QuickBooks Online are particularly impressive. You can generate profit and loss statements, balance sheets, cash flow reports, and dozens of customizable reports with just a few clicks. The dashboard provides a real‑time snapshot of your financial health, making it easy to spot trends and make data‑driven decisions. Our El Paso bookkeeping clients consistently tell us that having instant access to these reports has transformed how they manage their businesses.'
    ],
    features: [
      'Automatic bank feed imports and categorization',
      'Over 750 third‑party app integrations',
      'Advanced reporting and custom dashboards',
      'Multi‑user access with role‑based permissions',
      'Mobile app for on‑the‑go financial management'
    ]
  },
  {
    id: 'xero',
    number: 2,
    name: 'Xero',
    tagline: 'Beautiful Design Meets Powerful Features',
    image: 'https://readdy.ai/api/search-image?query=Modern%20cloud%20accounting%20software%20interface%20on%20desktop%20computer%20screen%20showing%20beautiful%20financial%20dashboard%20with%20colorful%20charts%20and%20clean%20design%2C%20bright%20contemporary%20office%20with%20plants%20and%20natural%20light%2C%20professional%20business%20technology&width=800&height=450&seq=xero-accounting-platform-review&orientation=landscape',
    imageAlt: 'xero-cloud-accounting-software-interface',
    price: 'Starting at $15/month',
    bestFor: 'Businesses wanting unlimited users',
    paragraphs: [
      'Xero has earned a devoted following among small business owners who appreciate its clean, intuitive interface and generous feature set. Originally from New Zealand, Xero has expanded globally and now serves millions of subscribers. Its standout feature is unlimited user access on every plan, making it an excellent choice for businesses with multiple team members who need financial visibility.',
      'The bank reconciliation process in Xero is one of the smoothest in the industry. The software uses machine learning to suggest matches between bank transactions and invoices, and it gets smarter over time as it learns your patterns. For busy El Paso business owners who want to spend less time on data entry, this automation is a game‑changer.',
      'Xero also excels in project tracking and inventory management. If you run a service‑based business and need to track time and expenses by project, or if you manage physical inventory, Xero provides built‑in tools that eliminate the need for separate software. The platform integrates with over 1,000 apps, giving you flexibility to build a tech stack that fits your unique workflow.'
    ],
    features: [
      'Unlimited users on all pricing plans',
      'Smart bank reconciliation with machine learning',
      'Built‑in project tracking and time management',
      'Over 1,000 app integrations available',
      'Inventory management with purchase orders'
    ]
  },
  {
    id: 'freshbooks',
    number: 3,
    name: 'FreshBooks',
    tagline: 'Built for Service‑Based Businesses',
    image: 'https://readdy.ai/api/search-image?query=Freelancer%20and%20small%20business%20owner%20creating%20professional%20invoices%20on%20laptop%20using%20cloud%20accounting%20software%2C%20cozy%20modern%20home%20office%20with%20warm%20lighting%2C%20clean%20interface%20showing%20time%20tracking%20and%20billing%20features%2C%20professional%20and%20approachable%20atmosphere&width=800&height=450&seq=freshbooks-invoicing-platform-review&orientation=landscape',
    imageAlt: 'freshbooks-cloud-invoicing-accounting-software',
    price: 'Starting at $19/month',
    bestFor: 'Freelancers and service‑based businesses',
    paragraphs: [
      'FreshBooks was originally designed as an invoicing tool, and that heritage shows in its exceptionally polished billing features. If your El Paso business relies heavily on sending invoices and tracking billable hours, FreshBooks delivers an experience that is hard to beat. The invoice creation process is fast, professional, and highly customizable, with automated payment reminders that help you get paid faster.',
      'Time tracking is another area where FreshBooks shines. You can log hours directly within the platform, assign them to specific projects or clients, and automatically convert tracked time into invoices. This seamless workflow is perfect for consultants, agencies, and any service provider who bills by the hour. The mobile app makes it easy to track time on job sites across El Paso without missing a minute.',
      'While FreshBooks may not have the depth of reporting that QuickBooks or Xero offer, it more than compensates with its user‑friendly design and excellent customer support. The platform is consistently rated as one of the easiest accounting tools to learn, making it ideal for business owners who want powerful features without a steep learning curve.'
    ],
    features: [
      'Professional, customizable invoice templates',
      'Built‑in time tracking with project management',
      'Automated payment reminders and late fees',
      'Expense tracking with receipt capture',
      'Award‑winning customer support team'
    ]
  },
  {
    id: 'wave',
    number: 4,
    name: 'Wave',
    tagline: 'Free Accounting for Budget‑Conscious Businesses',
    image: 'https://readdy.ai/api/search-image?query=Small%20business%20startup%20owner%20reviewing%20free%20accounting%20software%20on%20laptop%20in%20casual%20modern%20workspace%2C%20budget-friendly%20business%20tools%20concept%2C%20clean%20simple%20interface%20on%20screen%2C%20warm%20natural%20lighting%20with%20minimalist%20desk%20accessories%20and%20coffee&width=800&height=450&seq=wave-free-accounting-software-review&orientation=landscape',
    imageAlt: 'wave-free-cloud-accounting-software-small-business',
    price: 'Free (paid add‑ons available)',
    bestFor: 'Startups and solopreneurs on a tight budget',
    paragraphs: [
      'Wave stands out in the cloud accounting landscape for one compelling reason: its core accounting features are completely free. For El Paso startups and solopreneurs who are watching every dollar, Wave provides a surprisingly capable platform that includes invoicing, expense tracking, financial reporting, and bank connections at no cost whatsoever.',
      'Despite being free, Wave does not cut corners on essential features. You get unlimited invoicing, receipt scanning, and the ability to connect your bank accounts for automatic transaction imports. The reporting suite includes profit and loss statements, balance sheets, and sales tax reports. For many small businesses, these features are more than sufficient to maintain organized, accurate financial records.',
      'Wave generates revenue through optional paid services like payroll processing and payment processing, which means the core product is genuinely free without hidden limitations. If your business is just getting started or you have relatively simple financial needs, Wave is an excellent entry point into cloud‑based accounting. As your business grows, you can always transition to a more feature‑rich platform like QuickBooks with the help of a professional bookkeeping service.'
    ],
    features: [
      'Completely free core accounting features',
      'Unlimited invoicing and receipt scanning',
      'Automatic bank transaction imports',
      'Financial reporting including P&L and balance sheet',
      'Optional paid payroll and payment processing'
    ]
  },
  {
    id: 'zoho',
    number: 5,
    name: 'Zoho Books',
    tagline: 'Part of a Powerful Business Ecosystem',
    image: 'https://readdy.ai/api/search-image?query=Business%20team%20collaborating%20on%20integrated%20cloud%20software%20ecosystem%20on%20multiple%20screens%20showing%20CRM%20and%20accounting%20dashboards%2C%20modern%20open%20office%20with%20bright%20lighting%2C%20professional%20teamwork%20and%20technology%20integration%20concept%20with%20warm%20tones&width=800&height=450&seq=zoho-books-ecosystem-review&orientation=landscape',
    imageAlt: 'zoho-books-integrated-cloud-accounting-platform',
    price: 'Starting at $15/month',
    bestFor: 'Businesses already using Zoho products',
    paragraphs: [
      'Zoho Books is part of the larger Zoho ecosystem, which includes CRM, project management, HR, and dozens of other business applications. If your El Paso business already uses any Zoho products, adding Zoho Books creates a seamlessly integrated environment where data flows automatically between your sales, operations, and financial systems.',
      'The automation capabilities in Zoho Books are particularly noteworthy. You can create custom workflow rules that automatically categorize transactions, send payment reminders, update inventory levels, and trigger notifications based on specific conditions. These automations can save hours of manual work each week, freeing you to focus on growing your business rather than managing spreadsheets.',
      'Zoho Books also offers excellent multi‑currency and international features, making it a strong choice for El Paso businesses that work with suppliers or clients across the border in Mexico. The platform handles currency conversions, international tax compliance, and multi‑language invoicing with ease, which is a significant advantage for businesses in our border community.'
    ],
    features: [
      'Deep integration with 50+ Zoho applications',
      'Custom workflow automation rules',
      'Multi‑currency and international support',
      'Client portal for invoice viewing and payments',
      'Robust inventory and order management'
    ]
  },
  {
    id: 'sage',
    number: 6,
    name: 'Sage Business Cloud Accounting',
    tagline: 'Enterprise‑Grade Power for Growing Companies',
    image: 'https://readdy.ai/api/search-image?query=Corporate%20finance%20team%20analyzing%20detailed%20accounting%20reports%20on%20large%20monitor%20in%20professional%20office%2C%20enterprise-level%20business%20software%20showing%20advanced%20financial%20analytics%2C%20sleek%20modern%20workspace%20with%20warm%20ambient%20lighting%20and%20organized%20desk&width=800&height=450&seq=sage-business-cloud-accounting-review&orientation=landscape',
    imageAlt: 'sage-business-cloud-accounting-enterprise-software',
    price: 'Starting at $10/month',
    bestFor: 'Established businesses needing advanced compliance',
    paragraphs: [
      'Sage has been a trusted name in business accounting for over four decades, and their cloud offering brings that deep expertise to the modern era. Sage Business Cloud Accounting is designed for businesses that need more than basic bookkeeping, offering advanced features like multi‑company management, detailed audit trails, and comprehensive compliance tools.',
      'One of Sage’s greatest strengths is its approach to financial compliance and reporting. The platform provides built‑in tools for managing sales tax across multiple jurisdictions, generating compliance‑ready reports, and maintaining detailed audit trails that satisfy even the most thorough examinations. For El Paso businesses that operate across state lines or deal with complex tax situations, this level of compliance support is extremely valuable.',
      'Sage also offers a unique feature called Sage AI, which uses artificial intelligence to provide cash flow forecasts, identify unusual transactions, and suggest ways to improve your financial health. While other platforms are beginning to incorporate AI features, Sage’s implementation is among the most mature and practical for everyday business use.'
    ],
    features: [
      'Over 40 years of accounting expertise built in',
      'AI‑powered cash flow forecasting',
      'Multi‑company and multi‑jurisdiction support',
      'Comprehensive audit trail and compliance tools',
      'Automatic bank reconciliation with smart rules'
    ]
  },
  {
    id: 'kashoo',
    number: 7,
    name: 'Kashoo',
    tagline: 'Simplicity Without Sacrifice',
    image: 'https://readdy.ai/api/search-image?query=Small%20business%20owner%20happily%20using%20simple%20intuitive%20accounting%20app%20on%20tablet%20in%20bright%20modern%20cafe%20workspace%2C%20clean%20minimal%20interface%20showing%20easy%20bookkeeping%20features%2C%20relaxed%20professional%20atmosphere%20with%20natural%20light%20and%20warm%20tones&width=800&height=450&seq=kashoo-simple-accounting-review&orientation=landscape',
    imageAlt: 'kashoo-simple-cloud-accounting-software-small-business',
    price: 'Starting at $20/month',
    bestFor: 'Owners who want extreme simplicity',
    paragraphs: [
      'Kashoo takes a refreshingly different approach to cloud accounting by stripping away complexity and focusing on what small business owners actually need. If you have ever felt overwhelmed by the feature‑packed interfaces of larger platforms, Kashoo’s clean, straightforward design will feel like a breath of fresh air. It is built for business owners, not accountants, and that philosophy shows in every aspect of the user experience.',
      'The platform uses AI‑powered automation to handle much of the heavy lifting. Kashoo’s smart engine automatically categorizes transactions, matches receipts to expenses, and reconciles your bank accounts with minimal input from you. For El Paso business owners who want to stay on top of their finances without becoming bookkeeping experts, this hands‑off approach is incredibly appealing.',
      'Kashoo offers a single, all‑inclusive pricing plan that gives you access to every feature without worrying about tier limitations or surprise charges. You get unlimited invoicing, expense tracking, multi‑currency support, and direct bank connections all for one flat monthly fee. This transparent pricing model makes it easy to budget for your accounting software without any surprises.'
    ],
    features: [
      'AI‑powered automatic transaction categorization',
      'Single all‑inclusive pricing plan',
      'Extremely intuitive user interface',
      'Unlimited invoicing and expense tracking',
      'Direct bank feeds with smart matching'
    ]
  }
];

export default function SoftwareList() {
  return (
    <section className="pb-8">
      {softwareData.map((sw, idx) => (
        <div key={sw.id} id={sw.id} className="mb-16 scroll-mt-24">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-teal-700 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-white text-xl font-bold">{sw.number}</span>
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-900">{sw.name}</h2>
              <p className="text-teal-600 text-sm font-medium">{sw.tagline}</p>
            </div>
          </div>

          <img
            src={sw.image}
            alt={sw.imageAlt}
            title={`${sw.name} cloud accounting software review`}
            className="w-full h-[350px] object-cover object-top rounded-xl shadow-lg mb-8"
          />

          <div className="flex flex-wrap gap-4 mb-6">
            <span className="bg-teal-50 text-teal-700 text-sm font-medium px-4 py-1.5 rounded-full">
              {sw.price}
            </span>
            <span className="bg-orange-50 text-orange-700 text-sm font-medium px-4 py-1.5 rounded-full">
              Best for: {sw.bestFor}
            </span>
          </div>

          {sw.paragraphs.map((p, pIdx) => (
            <p key={pIdx} className="text-base text-gray-700 leading-relaxed mb-5">
              {p}
            </p>
          ))}

          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
            <h3 className="font-bold text-gray-900 mb-3 text-lg">Key Features</h3>
            <ul className="space-y-2">
              {sw.features.map((f, fIdx) => (
                <li key={fIdx} className="flex items-start gap-3 text-sm text-gray-700">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-base"></i>
                  </div>
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </div>

          {idx === 3 && (
            <div className="my-12 bg-gradient-to-r from-teal-50 to-orange-50 border-l-4 border-teal-500 p-8 rounded-r-xl">
              <p className="text-xl text-gray-800 italic leading-relaxed mb-3">
                &ldquo;The best accounting software is the one you will actually use consistently.
                Features mean nothing if the platform sits untouched because it feels too
                complicated.&rdquo;
              </p>
              <p className="text-sm text-gray-500 font-medium">&mdash; EP Bookkeeping Team</p>
            </div>
          )}
        </div>
      ))}
    </section>
  );
}
